'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.Language = void 0;
var Language;
(function (Language) {
    Language["ENGLISH"] = "en";
    Language["SWEDISH"] = "sv";
    Language["FINNISH"] = "fi";
    Language["GERMAN"] = "de";
    Language["NORWEGIAN"] = "no";
    Language["DUTCH"] = "nl";
    Language["TURKISH"] = "tr";
    Language["DANISH"] = "dn";
    Language["BRITISH"] = "gb";
    Language["AUSTRALIAN"] = "au";
    Language["CANADIAN"] = "ca";
    Language["NEW_ZEALAND"] = "nz";
    Language["RUSSIAN"] = "ru";
    Language["LATVIAN"] = "lv";
    Language["SPANISH"] = "es";
    Language["MACEDONIAN"] = "mk";
    Language["HUNGARIAN"] = "hu";
    Language["CANADIAN_FRENCH"] = "cf";
    Language["JAPANESE"] = "ja";
    Language["HINDI"] = "hi";
    Language["THAI"] = "th";
    Language["ARGENTINE_SPANISH"] = "ar";
    Language["ROMANIAN"] = "ro";
    Language["SOUTH_AFRICAN"] = "za";
    Language["CHILEAN"] = "cl";
    Language["MANDARIN"] = "zh";
    Language["PERU"] = "pe";
    Language["BRAZILIAN_PORTUGUESE"] = "bp";
    Language["ESTONIAN"] = "ee";
    Language["IRISH"] = "ei";
    Language["AMERICAN_ENGLISH"] = "en-US";
})(Language = exports.Language || (exports.Language = {}));
